import { Block } from '@/components/base/Block'
import { Row } from '@/components/base/Layout'
import { Text4 } from '@/components/base/Text'
import { useApp } from '@/hooks/useApp'
import borderLine, { borderSize } from '@/styles/border'
import borderRadius from '@/styles/border_radius'
import { display } from '@/styles/display'
import spaceStyle from '@/styles/space'
import textAlign from '@/styles/text_align'
import { type V1Tag, type V1AppColorTheme } from 'mnvm-mypage-app-ts-if'

export interface TagProps {
  text: string
  bg: V1AppColorTheme
}

export interface Props {
  tags: V1Tag[]
}

const Tag = ({ text, bg }: TagProps): JSX.Element => {
  const app = useApp()
  return (
    <>
      <Block
        display={display.INLINE_BLOCK}
        borderRadius={{ all: borderRadius.MAX }}
        border={{
          size: borderSize.S,
          line: borderLine.Solid,
          color: bg
        }}
        textAlign={textAlign.JUSTIFY}
        width={'auto'}
        padding={{ horizontal: spaceStyle.M, vertical: spaceStyle.XS }}
      >
        <Text4
          textColor={app.theme.mainTextColor}
          margin={{ all: spaceStyle.NONE }}
        >
          {text}
        </Text4>
      </Block>
    </>
  )
}

const Tags = ({ tags }: Props): JSX.Element => {
  const app = useApp()
  return (
    <div style={{ margin: '2px' }}>
      <Block padding={{ vertical: spaceStyle.XS }}>
        <Row gutter={8}>
          {tags.map((e, index) => (
            <Tag
              key={index}
              text={e.text ?? ''}
              bg={app.theme.fromAppThemeType(e.appThemeType)}
            />
          ))}
        </Row>
      </Block>
    </div>
  )
}

export default Tags
